import { Col, Row, Skeleton } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Specimen } from "../../../interface/specimen";

interface ICreateSales {
  setId: (data: string) => void;
  setActive: (data: boolean) => void;
  data: Specimen;
  isLoading: boolean;
}
export const SpecimenPreview: React.FC<ICreateSales> = ({
  setId,
  setActive,
  data,
  isLoading,
}) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const ratingData = [
    "Cost",
    "Quality",
    "Credit terms",
    "Reliability",
    "Logistic chain",
    "Communication",
  ];

  useEffect(() => {
    if (id) {
      setId(data?.specimen_id as string);
      setActive(data?.is_active as boolean);
    }
  }, [id, data?.specimen_id]);

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <div>
          <div className="sales-detail-border-main ">
            <Row className="w-full">
              <div className="sales-detail-border flex flex-col gap-2 w-full">
                <div className="sales-detail-placeholder">Item Name</div>
                <div className="sales-detail-sub-title common-work-break">
                  {data?.name?.name}
                </div>
              </div>
            </Row>
            <Row className="w-full">
              <div className="sales-detail-border flex flex-col gap-2 w-full">
                <div className="sales-detail-placeholder">Category</div>
                <div className="sales-detail-sub-title common-work-break">
                  <div className="flex gap-2">
                    {data?.category?.breadcrumb &&
                      data?.category?.breadcrumb?.map((item: any, index) => (
                        <div className="flex gap-2">
                          <span>{item}</span>
                          {data?.category?.breadcrumb &&
                            index !== data.category.breadcrumb.length - 1 && (
                              <img
                                src="/assets/rightArrow.svg"
                                alt="Right Arrow"
                              />
                            )}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Manufacturer</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.purpose?.name ? data?.purpose?.name : "-"}
                  </div>
                </div>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Grade</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.grade?.name ? data?.grade?.name : "-"}
                  </div>
                </div>
              </Col>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Quantity</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.quantity}
                  </div>
                </div>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Purpose</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.purpose?.name ? data?.purpose?.name : "-"}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Requested On</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.requested_on
                      ? moment(data?.requested_on).format("DD-MM-YYYY")
                      : "-"}
                  </div>
                </div>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Received On</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.received_on
                      ? moment(data?.received_on).format("DD-MM-YYYY")
                      : "-"}
                  </div>
                </div>
              </Col>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Expiry Period</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.expiry_date
                      ? moment(data?.expiry_date).format("DD-MM-YYYY")
                      : "-"}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <div className=" flex flex-col gap-2 sales-detail-border w-full">
                <div className="sales-detail-placeholder">Item Description</div>
                <div className="sales-detail-sub-title common-work-break">
                  {data?.description ? data?.description : "-"}
                </div>
              </div>
            </Row>
          </div>

          <Row className="w-full mt-24">
            <div className="sales-detail-border flex flex-col gap-2 w-full">
              <div className="sales-detail-placeholder">Remarks</div>
              <div className="sales-detail-sub-title  common-work-break">
                {data?.remarks ? data?.remarks : "-"}
              </div>
            </div>
          </Row>
          {data?.specification?.length > 0 && (
            <div>
              <Row className="mt-24p">
                <Col span={8} className="sales-detail-border">
                  <b>Specification</b>
                </Col>
                <Col span={8} className="sales-detail-border">
                  <b>Dimension</b>
                </Col>
                <Col span={8} className="sales-detail-border">
                  <b>Unit</b>
                </Col>
              </Row>

              {data?.specification?.map(
                (specification: any, specIndex: number) => (
                  <Row key={specIndex}>
                    {/* Material (Specification Name) */}
                    <Col span={8} className="sales-detail-border">
                      {specification?.specification_name}
                    </Col>

                    {/* Dimension */}
                    <Col span={8} className="sales-detail-border">
                      {specification?.valueFields?.map(
                        (field: any, fieldIndex: number) => (
                          <div key={fieldIndex}>
                            {field?.dimension_value?.join(", ") || "N/A"}
                          </div>
                        )
                      )}
                    </Col>

                    {/* Unit */}
                    <Col span={8} className="sales-detail-border">
                      {specification?.valueFields?.map(
                        (field: any, fieldIndex: number) => {
                          const unitName = specification?.unitOptions?.find(
                            (option: any) => option.value === field.unit
                          )?.label;

                          return <div key={fieldIndex}>{unitName || "-"}</div>;
                        }
                      )}
                    </Col>
                  </Row>
                )
              )}
            </div>
          )}
          {data?.specification?.length > 0 && (
            <Row className="w-full mt-24">
              <div className="sales-detail-border flex flex-col gap-2 w-full">
                <div className="sales-detail-placeholder">
                  Additional Specification
                </div>
                <div className="sales-detail-sub-title  common-work-break">
                  {data?.additional_specification
                    ? data?.additional_specification
                    : "-"}
                </div>
              </div>
            </Row>
          )}
        </div>
      )}
    </>
  );
};

export default SpecimenPreview;
